export default __webpack_public_path__ + "static/17-6ab5cdf4370c81e8bb9579f703a4f517.png";